import {
  CREATEPACKAGECHARGE,
  GETPACKAGECHARGE,
  UPDATEPACKAGECHARGE,
  DELETEPACKAGECHARGE,
  CREATEPACKAGESERVICEMAPPING,
GETPACKAGESERVICEMAPPING,
UPDATEPACKAGESERVICEMAPPING,
DELETEPACKAGESERVICEMAPPING,
CREATEPACKAGECOMPONENTMAPPING,
GETPACKAGECOMPONENTMAPPING,
UPDATEPACKAGECOMPONENTMAPPING,
DELETEPACKAGECOMPONENTMAPPING,
CREATEPACKAGECONSUMABLEMAPPING,
GETPACKAGECONSUMABLEMAPPING,
UPDATEPACKAGECONSUMABLEMAPPING,
DELETEPACKAGECONSUMABLEMAPPING,
CREATEPACKAGEDOCTORSHAREMAPPING,
GETPACKAGEDOCTORSHAREMAPPING,
UPDATEPACKAGEDOCTORSHAREMAPPING,
DELETEPACKAGEDOCTORSHAREMAPPING,
} from "../actions/types";

const initialState = {
  packagechargeList: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEPACKAGECHARGE:
      return {
        ...state,
        packagechargeSaveStatus: action.payload.success,
      };

    case GETPACKAGECHARGE:
      return {
        ...state,
        packagechargeList: action.payload.data,
      };

    case UPDATEPACKAGECHARGE:
      return {
        ...state,
        packagechargeUpdateStatus: action.payload.success,
      };

    case DELETEPACKAGECHARGE:
      return {
        ...state,
        packagechargeDeleteStatus: action.payload.success,
      };
// ==================================================
    // 1. SERVICE MAPPING
    // ==================================================
    case CREATEPACKAGESERVICEMAPPING:
      return { ...state, packageservicemappingSaveStatus: action.payload.success };
    case GETPACKAGESERVICEMAPPING:
      return { ...state, packageservicemappingList: action.payload.data };
    case UPDATEPACKAGESERVICEMAPPING:
      return { ...state, packageservicemappingUpdateStatus: action.payload.success };
    case DELETEPACKAGESERVICEMAPPING:
      return { ...state, packageservicemappingDeleteStatus: action.payload.success };

    // ==================================================
    // 2. COMPONENT MAPPING
    // ==================================================
    case CREATEPACKAGECOMPONENTMAPPING:
      return { ...state, packagecomponentmappingSaveStatus: action.payload.success };
    case GETPACKAGECOMPONENTMAPPING:
      return { ...state, packagecomponentmappingList: action.payload.data };
    case UPDATEPACKAGECOMPONENTMAPPING:
      return { ...state, packagecomponentmappingUpdateStatus: action.payload.success };
    case DELETEPACKAGECOMPONENTMAPPING:
      return { ...state, packagecomponentmappingDeleteStatus: action.payload.success };

    // ==================================================
    // 3. CONSUMABLE MAPPING
    // ==================================================
    case CREATEPACKAGECONSUMABLEMAPPING:
      return { ...state, packageconsumablemappingSaveStatus: action.payload.success };
    case GETPACKAGECONSUMABLEMAPPING:
      return { ...state, packageconsumablemappingList: action.payload.data };
    case UPDATEPACKAGECONSUMABLEMAPPING:
      return { ...state, packageconsumablemappingUpdateStatus: action.payload.success };
    case DELETEPACKAGECONSUMABLEMAPPING:
      return { ...state, packageconsumablemappingDeleteStatus: action.payload.success };

    // ==================================================
    // 4. DOCTOR SHARE MAPPING
    // ==================================================
    case CREATEPACKAGEDOCTORSHAREMAPPING:
      return { ...state, packagedoctorsharemappingSaveStatus: action.payload.success };
    case GETPACKAGEDOCTORSHAREMAPPING:
      return { ...state, packagedoctorsharemappingList: action.payload.data };
    case UPDATEPACKAGEDOCTORSHAREMAPPING:
      return { ...state, packagedoctorsharemappingUpdateStatus: action.payload.success };
    case DELETEPACKAGEDOCTORSHAREMAPPING:
      return { ...state, packagedoctorsharemappingDeleteStatus: action.payload.success };
    default:
      return state;
  }
}

